import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './acknowledgements/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}dashboard` }));
